/* eslint-disable react/no-unescaped-entities */

const AboutUsPT = () => {
  return (
    <>
      <h1>Sobre Nós</h1>
      <h2>Nossa Missão</h2>
      <div>
        Na mind-r.ai, embarcamos numa jornada para democratizar o acesso aos
        cuidados de saúde mental. Acreditamos no poder da tecnologia como uma
        ferramenta para derrubar barreiras, apagar fronteiras e tornar a terapia
        universalmente acessível. Já vimos os efeitos debilitantes que as
        condições de saúde mental não tratadas podem ter sobre indivíduos e
        sociedades - aumento das taxas de encarceramento, custos econômicos que
        chegam até 4% do PIB global, e mais. Nossa missão é mudar essa
        narrativa.
      </div>
      <div>
        Imaginamos um mundo onde todos, independentemente de sua localização,
        língua ou status econômico, podem acessar o apoio terapêutico de que
        precisam. Queremos normalizar a busca por ajuda, reduzir o estigma e
        criar um futuro onde priorizar a saúde mental seja a norma, não a
        exceção. Nosso objetivo não é apenas fornecer um serviço. É sobre
        iniciar um movimento em direção a uma melhor saúde mental para todos.
      </div>

      <h2>O Impacto Global da Saúde Mental</h2>
      <div>
        Problemas de saúde mental afetam profundamente o nosso mundo. Eles estão
        entre as principais causas de doença e deficiência em todo o mundo,
        afetando uma em cada quatro pessoas em algum momento de suas vidas
        <a
          href="https://www.who.int/news-room/fact-sheets/detail/mental-disorders"
          target="_blank"
        >
          [1]
        </a>
        . Especialistas estimam que problemas de saúde mental não tratados
        representam 13% do total da carga global de doenças
        <a
          href="https://www.who.int/news-room/fact-sheets/detail/mental-disorders"
          target="_blank"
        >
          [1]
        </a>
        .
      </div>
      <div>
        As implicações econômicas são impressionantes. A economia global poderia
        perder US$16 trilhões até 2030 devido a problemas de saúde mental por
        causa da diminuição da produtividade e do aumento dos custos de saúde
        <a
          href="https://www.thelancet.com/commissions/global-mental-health"
          target="_blank"
        >
          [2]
        </a>
        . Indivíduos com problemas de saúde mental não tratados muitas vezes
        enfrentam uma qualidade de vida reduzida, um maior risco de problemas de
        saúde física e taxas de desemprego aumentadas.
      </div>
      <div>
        Além dos fatores econômicos, problemas de saúde mental podem levar a
        níveis mais altos de violência e crime. Até 90% dos prisioneiros já
        passaram por problemas de saúde mental
        <a href="https://www.ncbi.nlm.nih.gov/books/NBK533137/" target="_blank">
          [3]
        </a>
        . Esses problemas também contribuem para problemas sociais como a falta
        de moradia e a desestruturação de famílias.
      </div>
      <div>
        Na mind-r.ai, estamos bem conscientes dos amplos impactos dos problemas
        de saúde mental e estamos comprometidos em fazer parte da solução. Ao
        democratizar o acesso à terapia, temos como objetivo aliviar o fardo da
        saúde mental um indivíduo de cada vez. Nossa missão vai além da saúde;
        nos esforçamos para criar um mundo melhor e mais compreensivo.
      </div>

      <h2>Nossa Abordagem</h2>
      <div>
        Marcamos nosso caminho para a democratização da terapia com inovação e
        acessibilidade. A inteligência artificial impulsiona nossa estratégia, e
        a utilizamos para entender e atender às necessidades e circunstâncias de
        cada indivíduo. Construímos algoritmos complexos para corresponder às
        preferências do usuário, criando experiências únicas e personalizadas.
      </div>
      <div>
        Temos fortes crenças no princípio da tecnologia impulsionada pela
        empatia. Projetamos cada recurso com as necessidades e experiências do
        usuário para integrar a terapia na vida cotidiana. Nossa abordagem se
        concentra na inclusividade, adaptando nossas soluções para todos,
        independentemente da língua, localização ou status socioeconômico.
      </div>
      <div>
        Em cada passo que damos, nossa missão de tornar a saúde mental
        universalmente acessível nos guia. Nosso compromisso com este objetivo
        molda nossa abordagem, influencia nossas decisões e nos impulsiona em
        direção à nossa visão.
      </div>
      <h2>Nosso Serviço</h2>
      <div>
        Na mind-r.ai, transformamos o conceito tradicional de terapia ao
        fornecer uma plataforma baseada em voz, conduzida por IA. Conheça a
        Solace, nossa terapeuta de IA, pronta para ouvir a qualquer momento, em
        qualquer lugar. Solace quebra as barreiras de tempo, língua e geografia,
        oferecendo tipo de terapia, duração, tema, língua e até sotaque de
        acordo com as preferências do usuário. Nossa oferta única abre um mundo
        de recursos de saúde mental para qualquer pessoa, a qualquer hora, em
        qualquer lugar.
      </div>
      <div>
        Como uma companheira adaptável, Solace adapta sua abordagem às
        necessidades de cada indivíduo. Desde fornecer conversas profundas e
        introspectivas até oferecer conversas casuais e reconfortantes, Solace
        se adapta aos humores e necessidades de nossos usuários. A terapia deve
        ser tão diversa e dinâmica quanto os indivíduos que a procuram.
      </div>
      <div>
        Após cada sessão de terapia com a Solace, geramos um resumo e ações
        práticas. Esses não são apenas boletins informativos; são ferramentas
        para empoderar os indivíduos em sua jornada contínua de saúde mental,
        fornecendo as percepções e os passos necessários para continuar a
        progredir. Temos orgulho de estar redefinindo a terapia, tornando-a mais
        acessível, personalizada e focada no usuário do que nunca. Nosso serviço
        é mais do que um produto; reflete nosso compromisso em democratizar o
        atendimento de saúde mental.
      </div>

      <h2>Nossos Valores</h2>
      <div>
        Como uma organização, nos orgulhamos de nossos valores e os levamos em
        cada decisão que tomamos. Estes são os princípios que nos orientam:
      </div>
      <div>
        <strong>Inovação</strong> - Estamos na vanguarda da tecnologia,
        utilizando a inteligência artificial para redefinir a terapia.
      </div>
      <div>
        <strong>Empatia</strong> - Nós priorizamos entender e atender às
        necessidades de nossos usuários.
      </div>
      <div>
        <strong>Inclusividade</strong> - Nós nos esforçamos para ser acessíveis
        a todos, independentemente da localização, língua ou status
        socioeconômico.
      </div>
      <div>
        <strong>Integridade</strong> - Estamos comprometidos com a honestidade e
        a transparência em tudo o que fazemos.
      </div>

      <h2>Junte-se a Nós</h2>
      <div>
        Você está pronto para dar o primeiro passo em direção a uma melhor saúde
        mental? Junte-se à comunidade mind-r.ai hoje mesmo e explore uma nova
        abordagem para a terapia. Conheça a Solace, sua terapeuta de IA, pronta
        para ouvir, entender e guiá-lo em sua jornada.
      </div>
    </>
  )
}

export default AboutUsPT
